import axios from '@utils/axiosInstance'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
    return {
        timeSlots: []
    }
}
export const state = getDefaultState()

export const getters = {}

export const mutations = {
    UPDATE_TIME_SLOTS(state, timeSlots) {
        state.timeSlots = timeSlots
    }
}

export const actions = {
    async fetchTimeSlots(store) {
        const queryString = `?sort=timeFrom`
        store.commit('UPDATE_TIME_SLOTS', [])
        try {
            const res = await axios.get(`${BASE}/mx/api/AccessDeviceTimeSlots/${queryString}`)
            store.commit('UPDATE_TIME_SLOTS', res.data.data)
            return res.data.data
        } catch (error) {
            throw new Error(
                `API Error occurred. ${BASE}/mx/api/AccessDeviceTimeSlots ${error}`,
            )
        }
    },

    async deleteTimeSlotAction({ store }, payload) {
        try {
            return await axios.post(
                `${BASE}/mx/api/AccessDeviceTimeSlots/remove`,
                payload
            )
        } catch (e) {
            throw Error(
                `API Error occurred at /mx/api/AccessDeviceTimeSlots/remove`,
            )
        }
    },

    async addTimeSlotAction({ store }, payload) {
        try {
            return await axios.post(
                `${BASE}/mx/api/AccessDeviceTimeSlots/add`,
                payload
            )
        } catch (e) {
            throw Error(
                `API Error occurred at /mx/api/AccessDeviceTimeSlots/add`,
            )
        }
    }
}